module.exports = __webpack_public_path__ + "img/29_34.505bdfdf.png";